import React from "react";

// This can either be a confirmation modal or a cancellation modal, depending on the type prop that is passed in.
// We don't want to show the X in the confirmation state

const PopupModal = ({ show, hideModal, confirm, message, modalType }) => {
  return (
    <div className={`${show ? "active popup-modal loading-modal" : ""}`}>
      <div className="dark-bg">{/* White frosty background */}</div>
      <div className="modal">
        <div class="modal-container">
          <button onClick={() => hideModal()} className={modalType === 'cancel' ? 'close-icon' : 'hide'}>
            <i class="material-icons">close</i>
          </button>
          <p>{message}</p>
          <div className="row justify-content-around">
            <div className="col-5">
              <button className="primary no-min" onClick={() => confirm()} data-e2e-id="modalYesButton">
                Yes
              </button>
            </div>
            <div className="col-5">
              <button className="secondary no-min" onClick={() => hideModal()}>
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupModal;



// WEBPACK FOOTER //
// ./src/components/confirmationModal/confirmation-modal.component.js